import React from "react";
import "./Relevent_news_update_card.css";

function Relevent_news_update_card({ imgSrc, onClick, data }) {
  return (
    <>
      <section className="Relevent_news_update_card" onClick={onClick}>
        <div className="img_holder">
          <img
            src={imgSrc}
            alt={data.name}
            className="Relevent_news_update_img"
          />
        </div>

        <div className="text_hodler">
          {/* <p>01 JUN 2024</p> */}
          <p>
            {new Date(data.createdAt).toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "short",
              year: "numeric",
            })}
          </p>
          {/* <h1>Luxury articles to gift antique collections</h1>
          <p>By Samanth and William</p> */}
          <h1>{data.name}</h1>
          <p>By {data.by_name}</p>
        </div>
      </section>
    </>
  );
}

export default Relevent_news_update_card;
